import ExcludeFromLookup from '../../../../../enums/ExcludeFromLookup';

export default {
  name: 'defaultBillingAddress',
  type: 'checkbox',
  value: true,
  key: 'billingAddress--useAsDefault',
  id: 'use-this-address-as-billing-default',
  label: 'checkout.billing.address.field.use.as.default',
  excludeFromAddressLookup: ExcludeFromLookup.AFTER,
};
